const swiper = new Swiper('.featured-articles__swiper', {
  pagination: {
    el: ".swiper-pagination",
    type: "progressbar",
    enabled: true
  },
  breakpoints: {
    768: {
      slidesPerView: 2.2,
      pagination: {
        enabled: false
      },
      navigation: {
        prevEl: '.featured-articles__swiper-nav--prev',
        nextEl: '.featured-articles__swiper-nav--next'
      },
      spaceBetween: 45
    }
  }
});

